import React, { createRef, useEffect } from 'react';
import CircleLink from '../CircleLink/CircleLink';
import { Heading } from '../ContentList/components/Header/Header.styles';
import { StyledContentList } from '../ContentList/ContentList.styles';
import { List } from './CircleLinkList.styles';
import ExpandButton from './components/ExpandButton';

const CircleLinkList = ({
    heading,
    expanded = false,
    items,
    location,
    onExpand,
    itemsLimit = 4,
    onItemClick,
}) => {
    const focusAnchor = createRef();
    const { query, pathname } = location;

    useEffect(() => {
        if (focusAnchor?.current && expanded) {
            focusAnchor.current.focus();
        }
    }, [expanded, focusAnchor]);

    let visibleCategories = items;
    if (items.length > itemsLimit && !expanded) {
        visibleCategories = items.slice(0, itemsLimit);
    }
    const showExpandButton = !expanded && items.length > itemsLimit;

    return (
        <>
            <StyledContentList>
                <Heading>{heading}</Heading>
                <List className="lp_rel">
                    {visibleCategories.map((category, i) => {
                        const { name, slug, thumbnailImage, imageAltText } = category;

                        const attr =
                            i === itemsLimit
                                ? {
                                      id: 'mer-relaterat',
                                      forwardedRef: focusAnchor,
                                      tabIndex: '-1',
                                  }
                                : undefined;

                        return (
                            <CircleLink
                                key={`related-${slug}`}
                                name={name}
                                slug={slug}
                                thumbnailImage={thumbnailImage}
                                imageAltText={imageAltText}
                                category={category}
                                index={i + 1}
                                {...attr}
                                onClick={(e) => onItemClick(e, category)}
                            />
                        );
                    })}
                </List>
                <ExpandButton show={showExpandButton} query={query} pathname={pathname} onExpand={onExpand} />
            </StyledContentList>
        </>
    );
};

export default CircleLinkList;
